import store from '@/store'

// TODO: create a login parent page and three children pages
export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@/pages/HomePage'))
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      loginRequired: true
    },
    component: () => lazyLoadView(import('@/pages/DashboardPage')),
    beforeEnter (to, from, next) {
      to.name === 'dashboard' ? next({ name: 'contacts' }) : next()
    },
    children: [
      {
        path: 'contacts',
        name: 'contacts',
        meta: {
          pageName: 'Contacts',
          massText: true
        },
        component: () => lazyLoadView(import('@/pages/Contact/ContactsPage'))
      },
      {
        path: 'contacts/edit-all',
        name: 'editAllContacts',
        meta: {
          pageName: 'Contacts'
        },
        component: () => lazyLoadView(import('@/pages/Contact/EditContactsPage'))
      },
      {
        path: 'contacts/:contactId',
        name: 'editContact',
        meta: {
          pageName: 'Contacts'
        },
        component: () => lazyLoadView(import('@/pages/Contact/EditContactPage'))
      },
      {
        path: 'groups',
        name: 'groups',
        meta: {
          pageName: 'Groups'
        },
        component: () => lazyLoadView(import('@/pages/Group/GroupsPage'))
      },
      {
        path: 'group/:groupId/contacts',
        name: 'groupContacts',
        meta: {
          pageName: 'Groups',
          massText: true
        },
        component: () => lazyLoadView(import('@/pages/Group/GroupContactsPage'))
      },
      {
        path: 'group/:groupId/edit-contacts',
        name: 'editGroupContacts',
        meta: {
          pageName: 'Groups'
        },
        component: () => lazyLoadView(import('@/pages/Group/EditGroupContactsPage'))
      },
      {
        path: 'categories',
        name: 'categories',
        meta: {
          pageName: 'Categories'
        },
        component: () => lazyLoadView(import('@/pages/Category/CategoriesPage'))
      },
      {
        path: 'category/:categoryId/contacts',
        name: 'categoryContacts',
        meta: {
          pageName: 'Categories',
          massText: true
        },
        component: () => lazyLoadView(import('@/pages/Category/CategoryContactsPage'))
      },
      {
        path: 'category/:categoryId/edit-contacts',
        name: 'editCategoryContacts',
        meta: {
          pageName: 'Categories'
        },
        component: () => lazyLoadView(import('@/pages/Category/EditCategoryContactsPage'))
      },
      {
        path: 'interests',
        name: 'interests',
        meta: {
          pageName: 'Interests'
        },
        component: () => lazyLoadView(import('@/pages/Interest/InterestsPage'))
      },
      {
        path: 'interest/:interestId/contacts',
        name: 'interestContacts',
        meta: {
          pageName: 'Interests',
          massText: true
        },
        component: () => lazyLoadView(import('@/pages/Interest/InterestContactsPage'))
      },
      {
        path: 'interest/:interestId/edit-contacts',
        name: 'editInterestContacts',
        meta: {
          pageName: 'Interests'
        },
        component: () => lazyLoadView(import('@/pages/Interest/EditInterestContactsPage'))
      },
      {
        path: 'polling',
        name: 'polling',
        meta: {
          pageName: 'Polling'
        },
        component: () => lazyLoadView(import('@/pages/Polling/PollingEventsPage'))
      },
      {
        path: 'polling/:pollingEventId/choices',
        name: 'pollingEventChoices',
        meta: {
          pageName: 'Polling'
        },
        component: () => lazyLoadView(import('@/pages/Polling/PollingEventChoicesPage'))
      },
      {
        path: 'polling/:pollingEventChoiceId/contacts',
        name: 'pollingChoiceContacts',
        meta: {
          massText: true
        },
        component: () => lazyLoadView(import('@/pages/Polling/PollingChoiceContactsPage'))
      },
      {
        path: 'polling/:pollingEventChoiceId/edit-contacts',
        name: 'editPollingChoiceContacts',
        component: () => lazyLoadView(import('@/pages/Polling/EditPollingChoiceContactsPage'))
      },
      {
        path: 'importContacts',
        name: 'importContacts',
        meta: {
          pageName: 'Import'
        },
        component: () => lazyLoadView(import('@/pages/ImportCSVContactPage'))
      },
      {
        path: 'automationRules',
        name: 'automationRules',
        component: () => lazyLoadView(import('@/pages/Automation/AutomationRulesPage'))
      }
    ]
  },
  {
    path: '/about',
    name: 'about',
    component: () => lazyLoadView(import('@/pages/AboutPage'))
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@/pages/LoginPage')),
    beforeEnter (to, from, next) {
      (store.getters['authentication/isAuthenticated']) ? next('/dashboard/contacts') : next()
    }
  },
  {
    path: '/phone-verification-request',
    name: 'phone-verification-request',
    component: () => lazyLoadView(import('@/pages/PhoneVerificationRequestPage')),
    beforeEnter (to, from, next) {
      store.getters['authentication/isAuthenticated'] ? next({ name: 'contacts' }) : next()
    }
  },
  {
    path: '/phone-verification-check',
    name: 'phone-verification-check',
    component: () => lazyLoadView(import('@/pages/PhoneVerificationCheckPage')),
    beforeEnter (to, from, next) {
      if (store.getters['authentication/isAuthenticated']) next({ name: 'contacts' })
      redirectRegistrationPage(to, next)
    }
  },
  {
    path: '/user-registration',
    name: 'user-registration',
    component: () => lazyLoadView(import('@/pages/UserRegistrationPage')),
    beforeEnter (to, from, next) {
      if (store.getters['authentication/isAuthenticated']) { next({ name: 'contacts' }) }
      redirectRegistrationPage(to, next)
    }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => lazyLoadView(import('@/pages/ResetPasswordPage'))
  }
]

// Redirect Registration Page based on the current step
function redirectRegistrationPage (to, next) {
  const currentStep = store.getters['account/getCurrentRegistrationStep']
  const nextPageStep = store.getters['account/getRegistrationStepByName'](to.name)
  const currentStepName = store.getters['account/getRegistrationStepByIndex'](currentStep)
  if (nextPageStep <= currentStep) {
    next()
  } else {
    next({ name: currentStepName })
  }
}

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView (AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    // loading: require('@views/loading').default,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    // error: require('@views/timeout').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000
  })

  return Promise.resolve({
    functional: true,
    render (h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    }
  })
}
